import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Dropdown, Menu } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { Flex, Button } from 'ui';
import Item from './item';

const ToolbarContainer = styled(Flex)`
  > div:not(:last-child) {
    border-right: 1px solid ${p => p.theme.colors.toolbar.seperator};
  }
`;

const MenuItem = styled(Menu.Item)`
    font-size: 1rem;
    color: ${p => p.theme.colors.themeSecondary}
    cursor: default;
`;

const Toolbar = ({ children }) => {
  let childrenArr = [];
  if (children && children.length > 1) {
    // eslint-disable-next-line prefer-destructuring
    children.forEach((c) => {
      if (c.length && c.length > 0) {
        childrenArr = [...childrenArr, ...children.reduce((a, i) => [...a, ...i], [])];
      } else {
        childrenArr = [...childrenArr, c];
      }
    });
  }

  if (children && !children.length) {
    childrenArr = [children];
  }

  const menuItem = childrenArr
    ?.filter(c => c && c.props && !c.props.showAsQuickAccess)
    ?.map((c, i) =>
      <MenuItem key={i} disabled={true}>
        {c}
      </MenuItem>,
    );

  return (
    <ToolbarContainer>
      {childrenArr?.filter(c => c && c.props && c.props.showAsQuickAccess)}
      {menuItem.length > 0 &&
        <Dropdown
          overlay={<Menu>{menuItem}</Menu>}
          trigger={['click']}
          getPopupContainer={triggerNode => triggerNode.parentNode}
        >
          <Button type='secondary' icon={<EllipsisOutlined />} />
        </Dropdown>
      }
    </ToolbarContainer>
  );
};

Toolbar.propTypes = {
  children: PropTypes.node,
};

Toolbar.Item = Item;

export default Toolbar;
